module.exports = __webpack_public_path__ + "img/Icon-survey-List.a737d022.svg";